import { render, staticRenderFns } from "./ModalLampEdit.vue?vue&type=template&id=2fed1a3c&scoped=true"
import script from "./ModalLampEdit.vue?vue&type=script&lang=js"
export * from "./ModalLampEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLampEdit.vue?vue&type=style&index=0&id=2fed1a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed1a3c",
  null
  
)

export default component.exports